<tabset [justified]="true">
  <tab>
    <ng-template tabHeading>
      <em class="icon-equalizer fa-lg"></em>
    </ng-template>
    <h3 class="text-center text-thin mt-4">Application Settings</h3>
    <div class="p-2">
      <h4 class="text-muted text-thin">Themes</h4>
      <div class="row row-flush mb-2">
        <div class="col mb-2">
          <div class="setting-color">
            <label>
              <input type="radio" name="setting-theme" [(ngModel)]="currentTheme" (ngModelChange)="setTheme()" value="A" />
              <span class="icon-check"></span>
              <span class="split">
                <span class="color bg-light-blue-700"></span>
                <span class="color bg-light-blue-700"></span>
              </span>
              <span class="color bg-white"></span>
            </label>
          </div>
        </div>
        <div class="col mb-2">
          <div class="setting-color">
            <label>
              <input type="radio" name="setting-theme" [(ngModel)]="currentTheme" (ngModelChange)="setTheme()" value="B" />
              <span class="icon-check"></span>
              <span class="split">
                <span class="color bg-indigo-700"></span>
                <span class="color bg-indigo-700"></span>
              </span>
              <span class="color bg-white"></span>
            </label>
          </div>
        </div>
        <div class="col mb-2">
          <div class="setting-color">
            <label>
              <input type="radio" name="setting-theme" [(ngModel)]="currentTheme" (ngModelChange)="setTheme()" value="C" />
              <span class="icon-check"></span>
              <span class="split">
                <span class="color bg-purple-900"></span>
                <span class="color bg-purple-900"></span>
              </span>
              <span class="color bg-white"></span>
            </label>
          </div>
        </div>
        <div class="col mb-2">
          <div class="setting-color">
            <label>
              <input type="radio" name="setting-theme" [(ngModel)]="currentTheme" (ngModelChange)="setTheme()" value="D" />
              <span class="icon-check"></span>
              <span class="split">
                <span class="color bg-green-900"></span>
                <span class="color bg-green-900"></span>
              </span>
              <span class="color bg-white"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="row row-flush mb-2">
        <div class="col mb-2">
          <div class="setting-color">
            <label>
              <input type="radio" name="setting-theme" [(ngModel)]="currentTheme" (ngModelChange)="setTheme()" value="E" />
              <span class="icon-check"></span>
              <span class="split">
                <span class="color bg-cyan-800"></span>
                <span class="color bg-cyan-800"></span>
              </span>
              <span class="color bg-white"></span>
            </label>
          </div>
        </div>
        <div class="col mb-2">
          <div class="setting-color">
            <label>
              <input type="radio" name="setting-theme" [(ngModel)]="currentTheme" (ngModelChange)="setTheme()" value="F" />
              <span class="icon-check"></span>
              <span class="split">
                <span class="color bg-pink-700"></span>
                <span class="color bg-pink-700"></span>
              </span>
              <span class="color bg-white"></span>
            </label>
          </div>
        </div>
        <div class="col mb-2">
          <div class="setting-color">
            <label>
              <input type="radio" name="setting-theme" [(ngModel)]="currentTheme" (ngModelChange)="setTheme()" value="G" />
              <span class="icon-check"></span>
              <span class="split">
                <span class="color bg-blue-grey-600"></span>
                <span class="color bg-blue-grey-600"></span>
              </span>
              <span class="color bg-white"></span>
            </label>
          </div>
        </div>
        <div class="col mb-2">
          <div class="setting-color">
            <label>
              <input type="radio" name="setting-theme" [(ngModel)]="currentTheme" (ngModelChange)="setTheme()" value="H" />
              <span class="icon-check"></span>
              <span class="split">
                <span class="color bg-blue-grey-900"></span>
                <span class="color bg-blue-grey-900"></span>
              </span>
              <span class="color bg-white"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </tab>
</tabset>
